import { useMutation, useQueryClient } from 'react-query';
import { useGlobals } from '../../globals-context';
import { updateBookingConfigurations } from '../api/booking-configurations';
import { publishUIMessage } from '../utils/notifications';

import { t } from '../../utils/i18n';
import { PaymentAvailabilityType } from '../types';

export function useUpdateBookingConfigurations() {
  const queryClient = useQueryClient();
  const { apiClient } = useGlobals() as any;

  return useMutation({
    mutationKey: ['update-booking-configurations'],
    mutationFn: ({
      merchantId,
      paymentAvailability,
    }: {
      merchantId: string;
      paymentAvailability: PaymentAvailabilityType;
    }) =>
      updateBookingConfigurations({
        apiClient,
        merchantId,
        paymentAvailability,
      }),
    onSuccess: (_data, variables) => {
      const { merchantId } = variables;
      const token = queryClient.getQueryData(['merchant_account_token']);

      queryClient.invalidateQueries({
        queryKey: ['bookingConfigs', 'v2', merchantId, token],
      });

      publishUIMessage(
        'success',
        t('notifications.booking-configurations.success-message') || ''
      );
    },
    onError: () => {
      publishUIMessage(
        'error',
        t('notifications.booking-configurations.error-message') || ''
      );
    },
  });
}
